import get from 'lodash/get';
import siteData from '../site_data_util';
import striptags from 'striptags';
import baseSeoUtil from '../base_seo_util';

export default function(state = {}, action = {}) {
  // Strip tags and trim the string
  const cleanString = string => striptags(string).trim();

  const hubPageAirtable = get(action, 'micHubPage.data.pageMeta[0]', {});
  const site = get(state, 'config.site');
  const siteConf = siteData || {};
  const seoTitle = cleanString(get(hubPageAirtable, 'seo_title'));
  const pageTitle = get(hubPageAirtable, 'page_title', false);
  const socialTitle = get(hubPageAirtable, 'social_headline', false);
  const socialDescription = get(hubPageAirtable, 'social_description', false);
  const title = pageTitle || seoTitle || 'Most Innovative Companies Hub';
  const hubImage = get(hubPageAirtable, 'social_image');
  const description =
    cleanString(get(hubPageAirtable, 'seo_description')) ||
    `An exclusive look at the World's most Innovative Companies.`;
  const url = `https://www.fastcomany.com/most-innovative-companies`;

  return baseSeoUtil({
    site,
    siteConf,
    overrideTitle: true,
    title,
    url,
    description,
    image: hubImage,
    config: get(state, 'config'),
    facebookTitleOverride: socialTitle,
    twitterTitleOverride: socialTitle,
    socialDescriptionOverride: socialDescription
  });
}
